import { Button, ButtonProps } from '@headlessui/react';
import { clsx } from 'clsx';

type TextButtonProps = Omit<ButtonProps, 'className'>;

export const TextButton = ({ children, ...props }: TextButtonProps) => (
  <Button
    {...props}
    className={clsx(
      'font-medium text-zinc-600 underline hover:text-zinc-700',
      'outline-2 outline-offset-2 focus-visible:outline-rose-700',
    )}
  >
    {children}
  </Button>
);
